import { ModalTemplate } from '../components/ModalTemplate';
import { modal } from '../utils/modal';
import { InfoConfig } from './types';

export const InfoDialog = ({
  body,
  onClose,
  title,
  errorMessage,
  onPrimaryButtonClick,
  ...restOfDialogBaseProps
}: InfoConfig & {
  onClose: () => void;
}) => (
  <ModalTemplate
    headerText={title}
    onCloseButtonClick={onClose}
    errorBlockMessage={errorMessage}
    onPrimaryButtonClick={() => {
      onPrimaryButtonClick?.();
      onClose();
    }}
    {...restOfDialogBaseProps}
  >
    {body}
  </ModalTemplate>
);

/**
 * Use this function when you would like to launch an Info dialog
 * anywhere in the app. The function is async so it should be treated as that.
 * Returns a promise
 * @param config
 * @returns void
 * @deprecated Avoid this in new code. Use `AnimatedModal` and control `isOpen`
 * like any other state. See #19797
 */
export const info = ({
  shouldCloseOnBackdropClick,
  shouldCloseOnEscapeKey,
  ...config
}: InfoConfig) => {
  return modal<void>(resolve => <InfoDialog onClose={resolve} {...config} />, {
    shouldCloseOnBackdropClick,
    shouldCloseOnEscapeKey,
  });
};
